<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li *ngFor="let breadcrumb of breadcrumbs let i = index"
        [ngClass]="{'breadcrumb-item': true, 'active': i == breadcrumbs.length - 1}"
        [attr.aria-current]="i == breadcrumbs.length - 1 ? 'page' : null ">
      <a id="bcId_{{i}}" routerLink="{{breadcrumb.url}}">{{breadcrumb.label}}</a>
    </li>
  </ol>
</nav>
